<immo-entity-select
  [field]="field()"
  [source]="dataSource"
  [labelSelector]="labelSelector"
  [subLabelSelector]="subLabelSelector"
  [label]="showLabel() ? label() : ''"
  [displayName]="displayName()"
  [placeholder]="placeholder()"
  [panelLabel]="panelLabel()"
  [notFoundText]="notFoundText()"
  [searchDebounceTime]="searchDebounceTime()"
  [theme]="theme()"
  [size]="size()"
  (valueChanged)="valueChanged.emit($event)"
>
  <ng-template immoEntitySelectRow let-row>
    <website-property-list-cell [entity]="$any(row)" />
  </ng-template>
</immo-entity-select>
